// removed by extract-text-webpack-plugin
module.exports = {"list-complaint":"list-complaint","news-tab-content":"news-tab-content","complaint-header":"complaint-header","complaint-table":"complaint-table","complaint-item":"complaint-item","new-complaint-item":"new-complaint-item","complaint-table-header":"complaint-table-header","complaint-table-list":"complaint-table-list","btn-see-more-wrap":"btn-see-more-wrap"};


//////////////////
// WEBPACK FOOTER
// ./components/users/sub-view/complaint-content/_ComplaintContent.scss
// module id = ./components/users/sub-view/complaint-content/_ComplaintContent.scss
// module chunks = 0